import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const notesOptions = {
  baseUrl: `${BACK_END_URL}/note`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class NotesClient extends CandyClient {
  constructor() {
    super(notesOptions);
  }

  async getNote(curso_id) {
    return this.get(`/curso/${curso_id}`, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }

  async createNote(noteData) {
    return this.post(`/create`, noteData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async updateNote(curso_id, noteData) {
    return this.put(`/update/${curso_id}`, noteData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async deleteNote(curso_id) {
    return this.delete(`/delete/${curso_id}`, null, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }
}